export default "__VITE_ASSET__BVBc$GOb__"